<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">
            Inventory Purchases
            <jni-spinner *ngIf="showLoader"></jni-spinner>
          </h2>
        </span>

        <div class="col-auto d-flex gap-1">
          <div
            class="ms-3 nav-link p-0 dropdown d-flex align-items-center"
            *ngIf="
              selectedSamplePO &&
              selectedSamplePO.length === 1 &&
              selectedSamplePO[0]?.purchaseOrderNumber?.includes('Temp') &&
              userRole === enumUserRole.Admin
            ">
            <i class="icon-Delete me-2"></i>
            <!-- <a class="link" (click)="deletePurchaseOrder()">Delete</a> -->
          </div>
          <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportExcel()"
              class="fullwdth secondary-btn" />
          </div>
          <!-- <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcelAll()">Export All excel</a>
      </div> -->
          <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
            <p-button
              label="Add New Inventory Purchase"
              icon="pi pi-plus"
              (click)="onSamplePORedirection()"
              class="fullwdth secondary-btn" />

            <!-- <i class="icon-Add me-2"></i>
            <a class="link" (click)="onSamplePORedirection()"
              >Add New Inventory Purchase</a
            > -->
          </div>
        </div>
      </span>

      <div class="col-12">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 264px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          [value]="inventoryPurchLists"
          [(selection)]="selectedSamplePO"
          styleClass="p-datatable-customers search-more"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="false"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          [paginator]="true"
          [rows]="defaultTake"
          [lazy]="true"
          (onLazyLoad)="getAllinventoryPurchListData($event)"
          [totalRecords]="totalRecords"
          [globalFilterFields]="[]"
          sortMode="multiple"
          (onFilter)="onFilter($event)"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th pSortableColumn="purchaseOrderNumber">
                Purchase Order #
                <p-sortIcon field="purchaseOrderNumber"></p-sortIcon>
              </th>
              <th *ngIf="userRole === enumUserRole.Admin">
                Purchase Order Status
              </th>
              <th>Arrival Status</th>
              <th>Store Name</th>
              <th>Client Account Name</th>
              <th>Job Name</th>
              <th>Subtotal</th>
              <th>Currency</th>
              <th>GP %</th>
              <th pSortableColumn="inHandsDate">
                In Hands Date <p-sortIcon field="inHandsDate"></p-sortIcon>
              </th>
              <th pSortableColumn="createdDate">
                Created <p-sortIcon field="createdDate"></p-sortIcon>
              </th>
              <th>Shipping Method</th>
              <th>Inventory Purchases</th>
              <th>Child PO</th>
              <!-- <th>Master PO</th> -->
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="purchaseOrderNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th *ngIf="userRole === enumUserRole.Admin">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="purchaseOrderStatus"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="arrivalStatus"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="storeName"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="clientAccountName"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="jobName"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="subTotal"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="currency"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th></th>
              <th>
                <jni-date-filter
                  [dataList]="inventoryPurchLists"
                  [filterMode]="filterMode"
                  [columnName]="inHandFieldName"
                  (emitCancelFilter)="onFilterInput($event, 'clear')"
                  (emitApplyFilter)="onFilterInput($event)">
                </jni-date-filter>
              </th>
              <th>
                <jni-date-filter
                  [dataList]="inventoryPurchLists"
                  [filterMode]="filterMode"
                  [columnName]="createdDateFieldName"
                  (emitCancelFilter)="onFilterInput($event, 'clear')"
                  (emitApplyFilter)="onFilterInput($event)">
                </jni-date-filter>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="shippingMethod"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th class="d-flex justify-content-center">
                <p-columnFilter
                  field="jniInventoryPurchase"
                  [showMenu]="false"
                  [showButtons]="false">
                  <ng-template
                    class="prospects-panel"
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback">
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="inventoryPurchaseFilter"
                      (onChange)="onFilterInput($event)"
                      inputId="binary"></p-checkbox>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th>
                <!-- <p-columnFilter field="childPo">
            <ng-template
              class="prospects-panel d-flex justify-content-between ms-2 me-auto"
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-checkbox
                [binary]="true"
                [(ngModel)]="childPoFilter"
                (onChange)="onFilterInput($event)"
                inputId="binary"
              ></p-checkbox>
            </ng-template>
          </p-columnFilter> -->
              </th>
              <!-- <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="masterPo"
              [showMenu]="false"
              (input)="onFilterInput($event)"
            ></p-columnFilter>
          </div>
        </th> -->
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-inventoryPurchLists
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="inventoryPurchLists"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  [disabled]="false"
                  [value]="inventoryPurchLists"
                  [pSelectableRow]="inventoryPurchLists"
                  (click)="checkboxSelection()"></p-tableCheckbox>
              </td>
              <td
                (click)="
                  getCurrentSamplePo(inventoryPurchLists.purchaseOrderNumber)
                ">
                <ng-container>
                  <a class="link-underline">
                    {{ inventoryPurchLists.purchaseOrderNumber }}
                  </a>
                </ng-container>
              </td>
              <td *ngIf="userRole === enumUserRole.Admin">
                {{ inventoryPurchLists.purchaseOrderStatus }}
              </td>
              <td>
                {{ inventoryPurchLists.arrivalStatus }}
              </td>
              <td>
                {{ inventoryPurchLists.storeName }}
              </td>
              <td>
                {{ inventoryPurchLists.clientAccName }}
              </td>
              <td>
                {{ inventoryPurchLists.jobName }}
              </td>
              <td>
                {{ inventoryPurchLists.subtotal }}
              </td>
              <td>
                {{ inventoryPurchLists.currency }}
              </td>
              <td>
                {{ inventoryPurchLists.gpPercentage | number: "1.2-2" }}
              </td>
              <td>
                {{ inventoryPurchLists.inHandsDate | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{ inventoryPurchLists.createdDate | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{ inventoryPurchLists.shippingMethod }}
              </td>
              <td style="text-align: center">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="inventoryPurchLists.inventoryPurchase"
                  [readonly]="true"
                  [ngStyle]="{ 'pointer-events': 'none' }" />
              </td>
              <td style="text-align: center">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="inventoryPurchLists.childPo"
                  [readonly]="true"
                  [ngStyle]="{ 'pointer-events': 'none' }" />
              </td>
              <!-- <td>
          <span class="p-column-title">Master PO</span>
          {{ inventoryPurchLists.masterPo }}
        </td> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No Inventory Purchases Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="samplePOSummaryDisplayModal"
  [displayModal]="samplePOSummaryDisplayModal"
  (closeEvent)="closeModalFromSamplePOSummary()"
  class="modal-header-sticky">
  <h1 class="panelHeading">Inventory PO Summary</h1>
  <div class="panelBody">
    <jni-inventory-purchase-summary
      [samplePOIdFromModal]="samplePOIdFromModal"
      [isFromStacker]="true"
      (cancelButtonEvent)="
        closeModalFromSamplePOSummary()
      "></jni-inventory-purchase-summary>
  </div>
</jni-modal-stacker>
